import React from 'react';
import * as Ons from 'react-onsenui';
import { reload } from '../util';
import { translate as _ } from '../util/i18n';

class ErrorBoundary extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {

            detailsOpen: false,
            error:       null,
            hasError:    false

        };

        this.resetApp    = this.resetApp.bind( this );
        this.showDetails = this.showDetails.bind( this );

    }

    componentDidCatch( error, info ) {

        console.log( 'components.ErrorBoundary.componentDidCatch', error, info );

    }

    static getDerivedStateFromError( error ) {

        console.log( 'components.ErrorBoundary.getDerivedStateFromError', error );

        return {

            error,
            hasError: true

        };

    }

    resetApp() {

        localStorage.clear();

        reload();

    }

    showDetails() {

        this.setState( { detailsOpen: true } );

    }

    render() {

        if ( this.state.hasError ) {

            return (

                <div className="error-boundary">

                    <h4>{_( 'Ups... da ist etwas schiefgelaufen :(' )}</h4>

                    <p className="buttons">
                        <Ons.Button modifier="large" onClick={reload}>{_( 'App neuladen' )}</Ons.Button>
                        <Ons.Button modifier="large outline" onClick={this.resetApp}>{_( 'App zurücksetzen' )}</Ons.Button>
                        <Ons.Button modifier="large outline" onClick={this.showDetails}>{_( 'Details anzeigen' )}</Ons.Button>
                    </p>

                    {

                        this.state.detailsOpen &&

                        <>

                            <p>{_( 'Details' )}:</p>

                            {

                                this.state.error &&

                                <div>

                                    <code>

                                        {this.state.error.stack}

                                    </code>

                                </div>

                            }

                        </>


                    }

                </div>

            );

        }

        return this.props.children;

    }
}

export default ErrorBoundary;